import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeByIdAction } from "../../../../store/actions/employee/EmployeeActions";
import { format } from "date-fns";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import Styles from "./employeeDetails.module.css";

const ViewEmployeeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [employee, setEmployee] = useState(null);

  const { loading, error, employeeById } = useSelector((state) => state.employee);

  useEffect(() => {
    if (!id) {
      navigate("/users");
      return;
    }
    dispatch(getEmployeeByIdAction(id, navigate));
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (employeeById && employeeById.length > 0) {
      const employeeData = employeeById[0];
      setEmployee({
        email: employeeData.email || "",
        name: employeeData.name || "",
        display_name: employeeData.display_name || "",
        phone: employeeData.phone || "",
        pincode: employeeData.pincode || "",
        city: employeeData.city || "",
        state: employeeData.state || "",
        address: employeeData.address || "",
        role_name: employeeData.role_name || "",
        emp_id: employeeData.emp_id || "",
        is_active: employeeData.is_active || false,
        dob: employeeData.dob ? new Date(employeeData.dob) : "",
      });
    }
  }, [employeeById]);

  if (loading) {
    return <ShimmerLoader width='95%' height='20%' count={4} />;
  }

  if (error) {
    return (
      <div class='alert alert-danger' role='alert'>
        Error while fetching employee data
      </div>
    );
  }

  if (!employee) {
    return <div>No employee data found</div>;
  }
  if (!loading && !error) {
    return (
      <>
        <div className='page-titles'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item'>
              <Link to={"/users"}>Users</Link>
            </li>
            <li className='breadcrumb-item active'>
              <Link to={"#"}>User Details</Link>
            </li>
          </ol>
        </div>

        <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td className='fw-bold'>Display Name</td>
                        <td>{employee.display_name || "-"}</td>
                        <td className='fw-bold'>Name</td>
                        <td>{employee.name || "-"}</td>
                      </tr>
                      <tr>
                        <td className='fw-bold'>Phone</td>
                        <td>{employee.phone || "-"}</td>
                        <td className='fw-bold'>Email ID</td>
                        <td>{employee.email || "-"}</td>
                      </tr>
                      <tr>
                        <td className='fw-bold'>Employee ID</td>
                        <td>{employee.emp_id || "-"}</td>
                        <td className='fw-bold'>Status</td>
                        <td>{employee.is_active ? "Active" : "In-Active"}</td>
                      </tr>
                      <tr>
                        <td className='fw-bold'>City</td>
                        <td>{employee.city || "-"}</td>
                        <td className='fw-bold'>State</td>
                        <td>{employee.state || "-"}</td>
                      </tr>
                      <tr>
                        <td className='fw-bold'>Role</td>
                        <td>{employee.role_name || "-"}</td>
                        <td className='fw-bold'>Date of Birth</td>
                        <td>{employee.dob ? format(employee.dob, "yyyy-MM-dd") : "-"}</td>
                      </tr>
                      <tr>
                        <td className='fw-bold'>Pincode</td>
                        <td>{employee.pincode || "-"}</td>
                        <td className='fw-bold'>Address</td>
                        <td>{employee.address || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ViewEmployeeDetails;
